import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ResourcesSection from './components/ResourcesSection';
import AboutSection from './components/AboutSection';
import SeoArticleSection from './components/SeoArticleSection';
import TestimonialsSection from './components/TestimonialsSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'VigorBuy Spreadsheet',
    url: 'https://vigorbuy.cam',
    description: 'The ultimate VigorBuy Spreadsheet resource center. Browse updated buying guides, product comparisons, category recommendations, and safety tips for smarter shopping in 2026.',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://vigorbuy.cam/?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ResourcesSection />
        <AboutSection />
        <SeoArticleSection />
        <TestimonialsSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}